/**
 * LanguageSingleSelect - Single language selection dropdown
 *
 * Simplified version of LanguageMultiSelect for single selection use cases
 */

import type { ReactElement } from "react";
import { LANGUAGE_OPTIONS } from "../../../utils/languageMapping";
import { Combobox } from "../ui/combobox";

interface LanguageSingleSelectProps {
  readonly value: string;
  readonly onChange: (language: string) => void;
  readonly disabled?: boolean;
  readonly placeholder?: string;
}

/**
 * Single-select language dropdown using the shared Combobox component
 */
export function LanguageSingleSelect({
  value,
  onChange,
  disabled = false,
  placeholder = "Language",
}: Readonly<LanguageSingleSelectProps>): ReactElement {
  const selectedLabel = LANGUAGE_OPTIONS.find((opt) => opt.value === value)?.label ?? placeholder;

  return (
    <Combobox
      value={value || null}
      onValueChange={(newValue) => {
        if (newValue) onChange(newValue);
      }}
      options={LANGUAGE_OPTIONS}
      placeholder={selectedLabel}
      searchPlaceholder="Search languages..."
      emptyMessage="No language found."
      disabled={disabled}
      triggerClassName="w-full h-9 px-3 text-sm bg-neutral-900/50 border-neutral-700"
    />
  );
}
